/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance, flow } from 'mobx-state-tree';
import { GeneralStatisticModel, IGeneralStatisticModel } from './models/generalSattistic.model';
import { AxiosResponse } from 'axios';
import axios from 'server';

const { model, maybeNull } = types;

export const DashboardStore = model('DashboardStore', {
  generalStatistic: maybeNull(GeneralStatisticModel),
})
  .views((self) => ({}))
  .volatile(() => ({}))
  .actions((self) => ({
    normalizeStatistic({ data }: AxiosResponse): IGeneralStatisticModel | null {
      self.generalStatistic = data.data;
      return self.generalStatistic;
    },
  }))
  .actions((self) => ({
    getStatistic: flow(function* () {
      const result = yield axios
        .get<IGeneralStatisticModel>(`dashboard/statistics `)
        .then(self.normalizeStatistic)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    getAppStatistic: flow(function* () {
      try {
        const response = yield axios.get<IGeneralStatisticModel>('apps/statistics');
        return response.data;
      } catch (error: any) {
        throw new Error(error);
      }
    }),

    getldapStatistic: flow(function* (header) {
      try {
        const response = yield axios.get<IGeneralStatisticModel>(`ldap/${header}/statistics`);
        return response.data;
      } catch (error: any) {
        throw new Error(error);
      }
    }),

    getDashboard: flow(function* () {
      try {
        const { data } = yield axios.get('user/dashboard');
        return data;
      } catch (error) {
        console.error('Dashboard API Error:', error);
        throw error;
      }
    }),
  }));

export type IDashboardStore = Instance<typeof DashboardStore>;
